import React from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

export const BackdropLoading: React.FC = () => {
  const loading = false;

  const theme = useTheme();

  const loadingProgress = 0;

  return (
    <Backdrop
      open={loading}
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      }}
    >
      <Stack
        width={1}
        height={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <Typography variant="h6" color="primary.main">
          Einen Augenblick bitte, der Inhalt wird geladen
        </Typography>

        <Box display="flex" position="relative">
          <CircularProgress
            variant={!!loadingProgress ? "determinate" : "indeterminate"}
            value={loadingProgress}
          />
          <Typography
            variant="caption"
            color="secondary.main"
            position="absolute"
            top={0}
            left={0}
            bottom={0}
            right={0}
            whiteSpace="nowrap"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {!!loadingProgress ? loadingProgress : "1"}%
          </Typography>
        </Box>
      </Stack>
    </Backdrop>
  );
};
